module.exports = __webpack_public_path__ + "img/RodrigoSantos.0633e3d3.png";